import styled from "styled-components";

export const Line = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    .first {
        flex-grow: 1;
    }
`;

export const Body = styled.div`

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 10px 20px;

  background: #f7f7f7;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.12);
  border-radius: 4px;

  img {
    width: 64px;
    height: 64px;
    margin: 10px 77px 5px;
  }

  span {
    font-family: 'Roboto';
    font-style: normal;
    font-size: 14px;
    line-height: 28px;
    /* or 175% */
    text-align: center;
    color: #000000;
  }
`;
